import PropTypes from 'prop-types';
import CsvUploadModal from 'components/molecules/csvUploadModal';
import { RESET_INTERACTION_STATUS } from 'services/dataService/resources';
import dataService from 'services/dataService';
import { downloadCSV } from 'utils';

const ResetInteractionStatus = ({ isOpen, toggle }) => {
  const uploadCsvFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const { error, data } = await dataService.uploadFile(
      RESET_INTERACTION_STATUS,
      formData,
    );

    if (error) {
      return { error };
    }

    if (data) {
      downloadCSV(data, `${file.name}_interactionStatusResult.csv`);
      if (toggle) {
        toggle();
      }
    }
    return {};
  };

  return (
    <CsvUploadModal
      isOpen={isOpen}
      toggle={toggle}
      title="CSV > Evelyn"
      sampleFileUrl="/csvTemplates/interactionStatusTemplate.csv"
      uploadCsvFile={uploadCsvFile}
    />
  );
};

ResetInteractionStatus.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ResetInteractionStatus;
